import React, { useEffect, useState, useCallback, Suspense, useTransition, useLayoutEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import LoaderComponent from '@components/atom/layout/loader';
import { keyword_Apart_Tab_Arr, keyword_Bpart_Tab_Arr } from '@models/keyword/keyword';
import { fetchKeywordGroupList, fetchKeywordList, fetchReqKeywordList } from '@reducers/keywordSlice';
import {
  setCurrentBpartTabType,
  setInitialApartKeywordList,
  setInitailBpartKeywordList,
} from '@reducers/keyword/keywordTrackingSlice';
import { RootState, AppDispatch } from '@reducers/index';

const AppInfo = React.lazy(() => import('@components/template/layout/appInfo/appInfo'));
const SwiperButtonComponent = React.lazy(
  () => import('@components/template/layout/swiper/keyword/tracking/swiperButton')
);
const Apart = React.lazy(() => import('@components/template/keyword/Apart/index'));
const Bpart = React.lazy(() => import('@components/template/keyword/Bpart/index'));

type Props = {};

const Tracking = (props: Props) => {
  const dispatch = useDispatch<AppDispatch>();
  const { userInfo } = useSelector(({ auth }: RootState) => auth);
  const { requestKeywordList } = useSelector(({ keyword }: RootState) => keyword);
  const [currentApartTab, setCurrentApartTab] = useState(keyword_Apart_Tab_Arr[0].value);
  const [currentBpartTab, setCurrentBpartTab] = useState(keyword_Bpart_Tab_Arr[0].value);

  const [isPending, startTransition] = useTransition();

  // 그룹리스트 && keywordListParam(키워드데이터 요청string[]) 요청처리!
  useLayoutEffect(() => {
    startTransition(() => {
      // if (!userInfo) {
      dispatch(fetchKeywordGroupList({ email: 'ss' }));
      dispatch(fetchReqKeywordList({ email: 'ss' }));
      // }
    });
  }, []);

  const apartTabHandler = useCallback(
    (tab) => {
      // apartKeywordListData 초기화 처리 (버튼 변경시 마다 초기화 처리 - 데이터 요청은 컴포넌트에서 처리)
      dispatch(setInitialApartKeywordList({}));
      setCurrentApartTab(tab);
    },
    [dispatch, setInitialApartKeywordList]
  );

  const bpartTabHandler = useCallback(
    (tab) => {
      // bpartKeywordListData 초기화 처리 (버튼 변경시 마다 초기화 처리 - 데이터 요청은 컴포넌트에서 처리)
      dispatch(setInitailBpartKeywordList({}));
      setCurrentBpartTab(tab);
      dispatch(setCurrentBpartTabType({ bpartTab: tab }));
    },
    [dispatch, setCurrentBpartTabType]
  );

  return (
    <>
      <div className="app-info">
        <Suspense fallback={<LoaderComponent />}>
          <AppInfo />
        </Suspense>
      </div>
      {/* Apart 부분 */}
      <div className="box-container">
        <Suspense fallback={<LoaderComponent />}>
          <SwiperButtonComponent
            buttonObjectArr={keyword_Apart_Tab_Arr}
            currentState={currentApartTab}
            currentStateHandler={apartTabHandler}
          />
        </Suspense>
        <Suspense fallback={<LoaderComponent />}>
          <Apart currentTab={currentApartTab} />
        </Suspense>
      </div>
      <Suspense fallback={<LoaderComponent />}>
        <Bpart tabArr={keyword_Bpart_Tab_Arr} currentTab={currentBpartTab} tabHandler={bpartTabHandler} />
      </Suspense>
    </>
  );
};

export default Tracking;
